import { stakingContractInfo } from "@/services/contract";
import { useContractRead } from "wagmi";
import { readContract } from "@wagmi/core";
import { useCallback, useEffect, useState } from "react";

export default function useUserStakingRewards(tokenIds: string[]) {
  const [rewards, setRewards] = useState<bigint[]>([]);

  const refetch = useCallback(
    async (_tokenIds?: string[]) => {
      const idList = _tokenIds || tokenIds;
      let rewards = [] as bigint[];
      const chunkSize = 10;
      for (let i = 0; i < idList.length; i += chunkSize) {
        const chunk = idList.slice(i, i + chunkSize);
        const res = await readContract({
          functionName: "calculateRewardsEarnedBatch",
          ...stakingContractInfo,
          args: [
            chunk.map((id) => {
              return Number(id);
            }),
          ],
        });
        rewards = rewards.concat(res as any);
      }
      setRewards(rewards);
    },
    [tokenIds]
  );

  useEffect(() => {
    refetch(tokenIds);
  }, [tokenIds]);

  return {
    refetch,
    rewards,
  };
}
